import React from 'react';
import { t } from 'i18next';
import { Typography } from '@mui/material';

function RenderTitle({ item, no_hours }) {
  const turnTOHour = (totalSeconds) => {
    const s = Math.max(0, Math.floor(Number(totalSeconds) || 0));
    const hours = Math.floor(s / 3600);
    const minutes = Math.floor((s % 3600) / 60);
    const seconds = s % 60;
    const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  };

  return (
    <div className='text-sm'>
      <div>
        <span className=''>{item?.name || ''}</span>
        <Typography
          color='secondary'
          className=''
          component='div'
          variant='caption'
        >
          {t('boss.crm.calls.durationCalls')}:{' '}
          {turnTOHour(item?.totaltalk) || ''}
        </Typography>
        <Typography
          color='secondary'
          className=''
          component='div'
          variant='caption'
        >
          {t('boss.crm.calls.durationTalk')}: {turnTOHour(item?.realtalk) || ''}
        </Typography>
      </div>
      {!no_hours && (
        <p>
          <span>{t('boss.crm.calls.duration')}: </span>
          <span className='text-blue-700'>
            {turnTOHour(item?.totaltalk) || ''}
          </span>
        </p>
      )}
    </div>
  );
}

export default RenderTitle;
